
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';

interface NameFieldProps {
  form: UseFormReturn<any>;
  name?: string;
  label?: string;
  placeholder?: string;
}

const NameField: React.FC<NameFieldProps> = ({ 
  form,
  name = "name",
  label = "Full Name",
  placeholder = "Enter your name"
}) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-hormony-charcoal">
            {label}
          </FormLabel>
          <FormControl>
            <Input
              {...field}
              type="text"
              placeholder={placeholder}
              className="appearance-none rounded-lg relative block w-full"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default NameField;
